import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { CATS } from "../components/Header";

export default function Shop() {
  const [sp, setSp] = useSearchParams();
  const [data, setData] = useState({ items: [], total: 0, pages: 1 });
  const [loading, setLoading] = useState(true);
  const category = sp.get("category") || "";
  const q = sp.get("q") || "";
  const sort = sp.get("sort") || "popular";
  const page = Number(sp.get("page") || 1);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { category: category || undefined, q: q || undefined, sort, page, limit: 24 } })
      .then((r) => setData(r.data)).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [category, q, sort, page]);

  const set = (k, v) => { const n = new URLSearchParams(sp); v ? n.set(k, v) : n.delete(k); if (k !== "page") n.delete("page"); setSp(n); };
  const title = q ? `Results for "${q}"` : CATS.find((c) => c[0] === category)?.[1] || "All products";

  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="shop-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold">{title}</h1>
          <p className="text-stone-500 mt-2 text-sm" data-testid="shop-total">{data.total.toLocaleString()} products</p>
        </div>
        <select data-testid="shop-sort-select" value={sort} onChange={(e) => set("sort", e.target.value)} className="h-10 rounded-full border px-4 text-sm bg-white">
          <option value="popular">Popular</option><option value="rating">Top rated</option>
          <option value="price_asc">Price: low to high</option><option value="price_desc">Price: high to low</option>
        </select>
      </div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar mt-6">
        {[["", "All"], ...CATS].map(([s, n]) => (
          <button key={s || "all"} data-testid={`shop-filter-${s || "all"}`} onClick={() => set("category", s)}
            className={`px-4 h-9 rounded-full text-sm whitespace-nowrap border transition-colors ${category === s ? "bg-[#1A1714] text-white border-[#1A1714]" : "bg-white hover:border-[#C85A32]"}`}>{n}</button>
        ))}
      </div>
      {loading ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">{Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[3/4] rounded-2xl bg-stone-200 animate-pulse" />)}</div>
      ) : data.items.length === 0 ? (
        <p className="mt-16 text-center text-stone-500" data-testid="shop-empty">No products here yet, more are being added soon.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8" data-testid="shop-grid">
          {data.items.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      )}
      {data.pages > 1 && (
        <div className="flex items-center justify-center gap-3 mt-12">
          <button data-testid="shop-prev-page" disabled={page <= 1} onClick={() => set("page", page - 1)} className="px-5 h-10 rounded-full border bg-white disabled:opacity-40">Previous</button>
          <span className="text-sm" data-testid="shop-page-indicator">Page {page} of {data.pages}</span>
          <button data-testid="shop-next-page" disabled={page >= data.pages} onClick={() => set("page", page + 1)} className="px-5 h-10 rounded-full border bg-white disabled:opacity-40">Next</button>
        </div>
      )}
    </div>
  );
}
